module.exports = __webpack_public_path__ + "img/facillgpd-consultor.1c914808.png";